<script setup>
import i18n from "@/i18n"
import { ref, onMounted, provide, watch, nextTick } from "vue"
import { useRoute } from "vue-router";
import basicFormCom from "./components/common/basicForm.vue"; //基本信息
import productInfoCom from "./components/detail/productInfo.vue"; //产品信息
import comfortInformationCom from "./components/detail/comfortInformation.vue"; //舒适度信息
import indicatorstandardsCom from "./components/detail/indicatorstandards.vue"; //指标信息
import otherInfoCom from "./components/detail/otherInfo.vue"; //其他信息
import {
    getHscode, postProduct, putProduct, getProductDetail, database_default_data_v3, getFileUrl, user_company_address_v3, getHscodeDetail, database_template_name_v3
} from "@/service";
import { gethscode_management_excel } from "@/service/apiList/products"
import { getUser_organization } from "@/service/apiList/common"
import { getMySuppliChainList } from "@/service/apiList/supplyChain"
import useMessage from "@/utils/hooks/useMessage" //信息hooks
import moment from "moment-timezone";
import { getLangValue, getLangValueByKey, getExcelData } from "@/utils/common"; //获取后端语言
const { alertInfo, openAlert, formValidataAlert } = useMessage()
import { showMessage } from "@/utils/hooks/message"
// provide 信息提示函数
provide('openAlert', openAlert)
const detailInfo = ref({}) // 模板详情 传递给所有子组件
const isCheckForm = ref(false) // 验证表单 传递给所有子组件
const showType = ref(true) // 是否显示结构信息
const templateId = ref('') // 用于切换模板
const supplyChainList = ref([]) // 我的供应链list
const myLoading = ref(false) //加载
provide('detailInfo', detailInfo)
provide('isCheckForm', isCheckForm)
provide('showType', showType)
provide('templateId', templateId)
provide('supplyChainList', supplyChainList)
const groupList = ref({}) // 所有组list
const groupList1 = ref([]) // 所有1级组list
const groupList2 = ref([]) // 所有2级组list
const groupList3 = ref([]) // 所有3级组list
const index_standards_list = ref({}) // 指标list
const index_standards_list1 = ref([]) //处理过后的指标list
const stylesPatternList = ref([]) // 存储成品样式与设计版型
provide('stylesPatternList', stylesPatternList)
provide('index_standards_list', index_standards_list)
const PageHeaderT = getLangValue("product-management", "title")
// const router = useRouter()
const route = useRoute()
const table_name = ref('') // 废除
const uploadData = ref([]) // 指标标准上传文件数据
const getMenuName = () => {
    // 获取当前menu name
    let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
    let arr = data.filter(item => item.id === route.query.tid)
    if (arr.length) {
        return `${i18n.global.locale == 'en' ? arr[0].name_en : arr[0].name}`
    }
    return ''
}
// const templateMenuList = ref([])
const PageHeaderItems = ref([
    {
        text: getLangValue("product-management", "title"),
        active: false,
        href: '',
    },
    {
        text: getMenuName(),
        active: false,
        href: '',
    },
    // {
    //     text: getLangValue("product-template","productInfo"),
    //     active: true,
    //     href: "#",
    // },
])
// 生产地址列表
const company_address_list = ref([])
const hscodeList = ref([]) // 所有的hscode list
// const template_hscodeValue = ref("") // 模板选择的数据库
const current_hscode = ref(null)  //表单填写的hscode值
provide('hscodeList', hscodeList)
provide('current_hscode', current_hscode)
//模板信息表单
const formData = ref({
    title: getLangValue("product-template.template_info"),
    fieldsList: [
        {
            label: '数据库名称',
            key: 'template_info_template_name',
            value: [],
            // type: 'list',
            // list: [],
            required: true,
        },
        {
            label: '目标市场',
            required: true,
            // type: 'country',
            // list: [],
            value: '',
            key: "template_info_destination_market"
        },
        {
            label: 'HS Code',
            required: true,
            // type: 'list',
            type: 'select',
            list: [],
            key: "template_info_hscode",
            value: []
        },
        {
            label: '描述',
            required: true,
            key: "template_info_description",
        },

        {
            label: '数据库公开类型',
            required: true,
            type: 'select',
            list: [
                {
                    label: getLangValue("product-management", "completelypublic"),
                    value: 2
                },

                {
                    label: getLangValue("product-management", "Opasc"),
                    value: 3
                },
                {
                    label: getLangValue("product-management", "notpublic"),
                    value: 1
                },
            ],
            key: "template_info_public_type",
        },
        {
            name: '供应链',
            label: '供应链',
            required: false,
            list: [],
            key: "template_info_supply_chain",
            value: [],
        },
        {
            label: '产地',
            required: true,
            key: "template_info_place_of_origin",
            list: company_address_list.value,
            type: 'select',
        },
        {
            label: '产品线名称',
            required: true,
            key: "template_info_production_line_name",
        },
        {
            label: '产品线编号',
            required: true,
            key: "template_info_production_line_number",
        },
        {
            label: "生产时间",
            required: true,
            type: 'date',
            key: "template_info_production_time",
        },

    ],
    addfieldsList: [],
})

//tab信息
const tabList = ref([
    { name: '产品信息', com: productInfoCom, ref: 'productInfoRef', show: true }, //产品信息组件
    { name: '舒适度信息', com: comfortInformationCom, ref: 'comfortInformationRef', show: true },
    // { name: '指标信息', com: indicatorstandardsCom, ref: 'indicatorstandardsRef', show: true },
    // { name: '报告', com: qualityInspectionReportCom, ref: 'qualityInspectionReportRef', show: false },
    { name: '其他信息', com: otherInfoCom, ref: 'otherInfoRef', show: true },
])
provide('tabList', tabList) // tab list
const refs = ref([]); // tab refs
const current_tab = ref(0) // 当前选中tab
provide('current_tab', current_tab)
const basicFormRef1 = ref(null) // basicFormRef
const company_list = ref([]) // 存储所有的检测机构
const templateNameList = ref([]) // 获取所有模板信息 用来展示组成结构信息
provide('templateNameList', templateNameList)
/** tab部分 */
const addRefs = (i) => {
    // 注册ref
    return (el) => {
        refs.value[i] = el;
    };
}

const handlerToggleTab = (i, id) => {
    // 切换tab
    current_tab.value = i
    if (id) {
        refs.value[i].current_tab = id
    }
}
/** tab部分 */

/**数据保存部分 */
const handlerCancel = () => {
    // 返回上一页
    // history.go(-1);
    window.close();
}

const getCompanyList = async () => {
    /***
     * ? 获取所有的检测机构
     * @param company_type 7 是检测机构
     */
    const resp = await getUser_organization({ company_type: 7 })
    if (resp.code == 0) {
        company_list.value = resp.payload;
    }
}

const get_user_company_address = async () => {
    // 获取公司生产地址
    let params = {
        user_id: sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).user_id : '' //目前登录没有返回
    }
    const resp = await user_company_address_v3(params)
    if (resp.code == 0) {
        company_address_list.value = resp.payload.map(item => {
            return {
                label: `${item.place_of_origin_number}${item.country}-${item.province}-${item.city}-${item.address1}`,
                value: item.id,
                id: item.id
            }
        })
        formData.value.fieldsList[6].list = [...company_address_list.value]
        // sessionStorage.setItem('company_address_list', JSON.stringify(company_address_list.value))
    }
    // }

}

const get_supply_chain_list = async () => {
    // 获取我的供应链
    let user_id = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).user_id : '';
    const resp = await getMySuppliChainList({ user_id: user_id, disabled: 0 }) // 开启状态下的供应链公司
    if (resp.code == 0) {
        supplyChainList.value = [...resp.payload]
        nextTick(() => {
            formData.value.fieldsList[5].list = [...resp.payload]
        })
    }
}



const getHscodeList = async () => {
    // hscode list
    const resp = await getHscode()
    if (resp.code == 0) {
        // hscodeList.value = resp.payload.map(item => { return { id: item.id, label: item.title, value: item.id } });
        hscodeList.value = resp.payload;
        formData.value.fieldsList[1].list = [...hscodeList.value]
    }
}

const getTemplateNameList = async () => {
    // 已开启的模板list
    const resp = await database_template_name_v3()
    if (resp.code == 0) {
        templateNameList.value = resp.payload;
    }
}


const scrollErrorElement = () => {
    // 定位到必填的元素
    nextTick(() => {
        // 定位到必填的元素
        const elements = document.getElementsByClassName('is-invalid');
        // console.log(elements);
        if (elements.length) {
            elements[0].scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    })
}

const handlerSubmit = async () => {
    if (route.query.type == 'add' && !route.query.p_id) {
        openAlert({
            variant: "danger",
            content: '请选择模板！！',
        })
        scrollErrorElement()
        return false
    }
    //基本信息
    const { checkResult: res } = basicFormRef1.value.checkForm();
    if (!res) {
        openAlert({
            variant: "danger",
            content: getLangValue("base.requiredinformation"),
        })
        scrollErrorElement()
        return false
    }
    //产品信息-基本信息
    const { checkResult: res1, message } = refs.value[0].basicFormRef.checkForm();
    if (!res1) {
        current_tab.value = 0
        openAlert({
            variant: "danger",
            content: message ? message : getLangValue("base.requiredinformation"),
        })
        scrollErrorElement()
        return false
    }
    // 组成结构信息校验
    const res1_1 = refs.value[0].checkFormCompositionStructure();
    if (!res1_1) {
        current_tab.value = 0
        openAlert({
            variant: "danger",
            content: getLangValue("product-template", "requireCompositionStructure"),
        })
        scrollErrorElement()
        return false
    }
    // 组成结构信息校验1
    const res1_1_1 = refs.value[0].checkFormCompositionStructure1();
    if (!res1_1_1) {
        current_tab.value = 0
        openAlert({
            variant: "danger",
            content: getLangValue("product-template", "compositionStructureSum"),
        })
        scrollErrorElement()
        return false
    }
    // 组成结构信息校验2
    const res1_1_2 = refs.value[0].checkFormCompositionStructure2();
    if (!res1_1_2) {
        current_tab.value = 0
        openAlert({
            variant: "danger",
            content: getLangValue("product-template", "compositionStructureError"),
        })
        scrollErrorElement()
        return false
    }
    // 产品信息图片信息的校验
    const res1_2 = refs.value[0].checkFormUpload();
    if (!res1_2) {
        current_tab.value = 0
        openAlert({
            variant: "danger",
            content: getLangValue("product-template", "requireupload"),
        })
        scrollErrorElement()
        return false
    }

    // 产品信息自定义字段的校验
    const res1_3 = refs.value[0].checkForm();
    if (!res1_3) {
        current_tab.value = 0
        openAlert({
            variant: "danger",
            content: getLangValue("base.requiredinformation"),
        })
        scrollErrorElement()
        return false
    }
    // 舒适度信息上传框字段校验
    const res2 = refs.value[1].checkFileUpload();
    if (!res2) {
        current_tab.value = 1
        openAlert({
            variant: "danger",
            content: getLangValue("base.requiredinformation"),
        })
        scrollErrorElement()
        return false
    }
    // 舒适度信息底部上传框字段校验
    const res2_1 = refs.value[1].checkFileUpload1();
    if (!res2_1) {
        current_tab.value = 1
        openAlert({
            variant: "danger",
            content: getLangValue("base.requiredinformation"),
        })
        scrollErrorElement()
        return false
    }

    // 指标标准信息校验
    // const { checkRes: res3, checkStatus } = refs.value[2].checkForm();
    // // console.log(checkStatus);
    // if (!res3) {
    //     current_tab.value = 2
    //     openAlert({
    //         variant: "danger",
    //         content: checkStatus == 1 ? getLangValue("hscode.requiredIndicatorFile") : getLangValue("hscode.requiredIndicatorName"),
    //     })
    //     return false
    // }
    // 报告信息校验
    // const res4 = refs.value[3].checkForm();
    // if (!res4) {
    //     current_tab.value = 3
    //     openAlert({
    //         variant: "danger",
    //         content: getLangValue("base.requiredinformation"),
    //     })
    //     return false
    // }
    // 其他信息校验
    const res5 = refs.value[tabList.value.length - 1].checkForm();
    if (!res5) {
        current_tab.value = tabList.value.length - 1
        openAlert({
            variant: "danger",
            content: getLangValue("base.requiredinformation"),
        })
        scrollErrorElement()
        return false
    }

    //提交数据
    const changeFormData = () => {
        const arr = formData.value.fieldsList.map(item => {
            let m = {
                name: item.name,
                name_en: item.name_en,
                type: 1,
                key: item.key,
                value: item.value,
                show: true,
                deletable: false,
                required: item.key == 'template_info_supply_chain' ? false : true,
                extra: {},
                children: [],
                disabled: false,
            }
            // if (item.key == 'HSCode数据库') {
            //     // console.log(item.value);
            //     m.extra = { value: item.value }
            //     let x = [...item.value]
            //     m.value = x.pop()
            // }
            if (item.key == 'template_info_production_time') {
                m.extra = { value: item.value }
                m.value = moment(m.value).format("YYYYMMDDHHmm")
            }
            return m
        })
        // console.log(arr);
        return arr
    }
    let params = {
        // hscode: '6653dc9f5a60581445cb9d47',
        // database: '6653dc9f5a60581445cb9d47',
        // production_line_id: route.query.p_id,
        template_info: {
            deletable: false,
            key: "template_info",
            name: getLangValueByKey('product-template.template_info'),
            name_en: getLangValueByKey('product-template.template_info', 'en'),
            required: true,
            show: true,
            type: 1,
            value: null,
            children: [...changeFormData(), ...formData.value.addfieldsList]
        },
        product_info: {
            "name": tabList.value[0].name,
            name_en: tabList.value[0].name_en, // 新的名称可以修改
            "type": 1,
            "key": "product_info",
            "value": null,
            "show": true,
            "deletable": false,
            "required": true,
            children: [
                {
                    deletable: false,
                    key: "product_info_base_info",
                    name: getLangValueByKey('product-template.product_info_base_info'),
                    name_en: getLangValueByKey('product-template.product_info_base_info', 'en'),
                    required: false,
                    show: true,
                    type: 1,
                    value: null,
                    children: [],
                }
            ]
        },
        comfort_info: {
            deletable: false,
            key: "comfort_info",
            name: tabList.value[1].name,
            name_en: tabList.value[1].name_en,
            required: false,
            show: tabList.value[1].show,
            type: 1,
            value: null,
            children: [],
        },
        quality_inspection_report: {
            children: [],
            deletable: true,
            key: "quality_inspection_report",
            name: getLangValueByKey('product-template.quality_inspection_report'),
            name_en: getLangValueByKey('product-template.quality_inspection_report', 'en'),
            required: false,
            show: false,
            type: 3,
            value: null,
            // extra: {
            //     id: 'qualityInspectionReport',
            //     accept: '.doc,.docx,.pdf', // 接受的类型
            //     fileList: [],
            //     fileMaxSize: 1024 * 1024 * 50, //50M
            //     showDelete: true,
            // },
        },
        extra_info: {
            deletable: false,
            key: "other_info",
            name: tabList.value[tabList.value.length - 1].name,
            name_en: tabList.value[tabList.value.length - 1].name_en,
            required: false,
            show: tabList.value[tabList.value.length - 1].show,
            type: 1,
            value: null,
            children: [],
        },
        index_standard_info: {
            deletable: false,
            key: "index_standard_info",
            name: getLangValueByKey('product-template.index_standard_info'),
            name_en: getLangValueByKey('product-template.index_standard_info', 'en'),
            required: false,
            show: true,
            type: 1,
            value: null,
            children: [],
            extra: {
                groupList: groupList.value,
                index_standards_list: index_standards_list.value
            },
        },
        table_name: table_name.value,
    };
    const changeFormData1 = () => {
        const arr = refs.value[0].formData.fieldsList.map(item => {
            if (typeof (item.value) == "string") {
                item.value = item.value.trim()
            }
            if(item.key =='product_info_base_info_inventory_unit') {
                item.value =`${item.value}` // 后台这个值为字符串  需要把数字转为字符串
            }
            return {
                ...item,
                type: Number(item.type1),
            }
        })
        return arr
    }
    //设置产品信息-基本信息
    params.product_info.children[0].children = [...changeFormData1(), ...refs.value[0].formData.addfieldsList]
    //设置产品信息-组成结构
    let zcjg = {
        deletable: true,
        key: `product_info_base_info_structure`,
        name: getLangValueByKey('product-template.product_info_base_info_structure'),
        name_en: getLangValueByKey('product-template.product_info_base_info_structure', 'en'),
        required: false,
        extra: { show: refs.value[0].compositionStructureList.length ? true : false },
        show: refs.value[0].compositionStructureList.length ? true : false,
        type: 1,
        value: null,
        children: [],
    }
    // key不为空的项才提交  后台需要根据key来判断是否提交
    refs.value[0].compositionStructureList.filter(item => item.value).forEach((element, index) => {
        let m = {
            deletable: true,
            key: element.value,
            name: element.name,
            name_en: element.name_en,
            required: element.required,
            show: element.show,
            type: 5,
            value: element.value,
            children: [],
            extra: {
                template_type: element.extra?.template_type,
                data: element.tableList.map(item => {
                    return {
                        table_name: item.organization ? item.organization.table_name : item.table_name,
                        database_id: item.database_id,
                        layer: item.value2,
                        proportion: item.value3,
                        name: item.name,
                        pid: item.pid || ''
                    }
                }),
                myData: {
                    myKey: '组成结构',
                    showDelete: true,
                    tableList: [],
                    tableData: [],
                    inputVal: '',
                    key: `组成结构-${index}`,
                }
            }
        }
        zcjg.children.push(m)
    });
    params.product_info.children.push(zcjg)
    // 产品信息图片部分修改
    refs.value[0].uploadList.forEach(element => {
        let m = {
            children: [],
            deletable: true,
            key: element.key,
            name: element.name,
            name_en: element.name_en,
            required: element.required,
            show: element.show,
            type: 3,
            value: element.fileList.filter(item => typeof item != 'undefined').map(item => { return item?.id }), // 有的图片没了
            showDelete: false,
            extra: {
                id: element.id,
                accept: element.accept, // 接受的类型
                fileList: [],
                fileMaxSize: element.fileMaxSize, //10M
                myKey: element.mykey ? element.mykey : element.key,
            },
        }
        if (element.key.indexOf('product_info_virtual_fit') > -1) {
            m.children = element.fieldsList.map(item => {
                return {
                    children: [],
                    deletable: false,
                    key: item.key,
                    name: item.name,
                    name_en: item.name_en,
                    required: item.required ? item.required : false,
                    show: true,
                    type: 2,
                    unit: null,
                    value: item.value,
                }
            })
        }
        params.product_info.children.push(m)
    });
    // 输入框的信息
    refs.value[0].inputList.forEach((element) => {
        let m = {
            children: [],
            deletable: true,
            key: element.key,
            name: element.name,
            name_en: element.name_en,
            required: false,
            show: element.show,
            type: 1,
            value: element.value,
            extra: {},
        }
        params.product_info.children.push(m)
    })
    // 自定义字段
    refs.value[0].customFieldsList.forEach((element) => {
        let m = {
            children: [],
            deletable: true,
            key: element.key,
            name: element.name,
            name_en: element.name_en,
            required: false,
            show: element.show,
            type: 1,
            value: null,
            extra: {},
        }
        m.children = element.fieldsList.map(item => {
            return {
                children: [],
                deletable: false,
                key: item.key,
                name: item.name,
                name_en: item.name_en,
                // required: true,
                show: true,
                type: 2,
                unit: item.unit,
                value: item.value,
                required: item.required ? item.required : false,
            }
        })
        if (!element.showUpload) {
            // m.key = `文本项-${index}`
            m.extra.myKey = '文本项'
            m.extra.showUpload = element.showUpload
            m.extra.showDelete = element.showDelete
        } else {
            // m.key = `文本项+附件项-${index}`
            m.extra.myKey = '文本项+附件项'
            m.extra.showUpload = element.showUpload
            m.extra.showDelete = element.showDelete
            m.extra.id = element.id
            m.extra.accept = element.accept
            m.extra.fileList = element.fileList
            m.extra.fileMaxSize = element.fileMaxSize
            m.value = element.fileList.map(item => { return item.id })
        }
        params.product_info.children.push(m)
    })

    //设置舒适度信息-热湿舒适度
    refs.value[1].heatList.forEach((item) => {
        let m = {
            children: [],
            deletable: false,
            key: "comfort_info_humidity_heat_comfort",
            name: item.name,
            name_en: item.name_en,
            required: true,
            show: item.show,
            type: 3,
            value: item.fileList.map(item => { return item.id }),
            fileList: [],
            showDelete: true,
        }
        params.comfort_info.children.push(m)
    })

    // 设置舒适度信息-自定义的字段list 包含有上传框的
    refs.value[1].customFieldsList.forEach((element) => {
        let m = {
            children: [],
            deletable: true,
            key: element.key,
            name: element.name,
            name_en: element.name_en,
            required: false,
            show: true,
            type: 1,
            value: null,
            extra: {},
        }

        m.children = element.fieldsList.map(item => {
            return {
                children: [],
                deletable: false,
                key: item.key,
                name: item.name,
                name_en: item.name_en,
                // required: true,
                show: true,
                type: 2,
                unit: item.unit,
                value: item.value,
                required: item.required ? item.required : false,
                extra: {
                    type: item.type ? item.type : '',
                    list: item.list ? item.list : '',
                }
            }
        })
        if (!element.showUpload) {
            // m.key = `文本项-${index}-${m.name}`
            m.extra.myKey = '文本项'
            m.extra.uukey = element.uukey
            m.extra.showUpload = element.showUpload
            m.extra.hideCopy = element.hideCopy
            m.extra.showName = element.showName
            m.extra.showDelete = element.showDelete
            m.extra.showTable = element.showTable ? true : false,
                m.extra.tabList = element.tabList ? element.tabList : []
        } else {
            // m.key = `文本项+附件项-${index}-${m.name}`
            m.extra.myKey = '文本项+附件项'
            m.extra.uukey = element.uukey
            m.extra.showUpload = element.showUpload
            m.extra.hideCopy = element.hideCopy
            m.extra.showName = element.showName
            m.extra.showDelete = element.showDelete
            m.extra.info = element.info
            m.extra.id = element.id
            m.extra.accept = element.accept
            m.extra.fileMaxSize = element.fileMaxSize
            m.extra.fileList = element.fileList
            m.value = element.fileList.map(item => { return item.id })
            m.extra.showTable = element.showTable ? true : false,
                m.extra.tabList = element.tabList ? element.tabList : []
        }
        if (m.key == 'comfort_info_ftt' || m.extra.uukey == 'FTT') {
            // m.key = 'FTT织物触觉测试'
            // m.name = 'FTT织物触觉测试'
            let x = {
                type: 2,
                key: 'template_attachments',
                name: '附件',
                value: element.fileList.map(item => { return item.id }),
                show: true,
                required: false,
                deletable: false,
                extra: null
            }
            m.children.push(x);
        }
        if (m.key == 'comfort_info_mmt' || m.extra.uukey == 'water') {
            // m.key = '织物液态水分传导性能'
            // m.name = '织物液态水分传导性能'
            let x = {
                type: 2,
                key: 'template_attachments',
                name: '附件',
                value: element.fileList.map(item => { return item.id }),
                show: true,
                required: false,
                deletable: false,
                extra: null
            }
            m.children.push(x);
        }
        params.comfort_info.children.push(m)
    })
    //设置舒适度信息 自定义字段list 底部
    refs.value[1].customFieldsList1.forEach((element) => {
        let m = {
            children: [],
            deletable: true,
            key: element.key,
            name: element.name,
            name_en: element.name_en,
            required: false,
            show: element.show,
            type: 1,
            value: null,
            extra: {},
        }
        m.children = element.fieldsList.map(item => {
            return {
                children: [],
                deletable: false,
                key: item.key,
                name: item.name,
                name_en: item.name_en,
                // required: true,
                required: item.required ? item.required : false,
                show: true,
                type: 2,
                unit: item.unit,
                value: item.value,
            }
        })
        if (!element.showUpload) {
            // m.key = `文本项-${index}`
            m.extra.myKey = '文本项'
            m.extra.showUpload = element.showUpload
            m.extra.showDelete = element.showDelete
        } else {
            // m.key = `文本项+附件项-${index}`
            m.extra.myKey = '文本项+附件项'
            m.extra.showUpload = element.showUpload
            m.extra.showDelete = element.showDelete
            m.extra.id = element.id
            m.extra.accept = element.accept
            m.extra.fileList = element.fileList
            m.extra.fileMaxSize = element.fileMaxSize
            m.value = element.fileList.map(item => { return item.id })
        }
        params.comfort_info.children.push(m)
    })

    // 指标标准信息
    params.index_standard_info.value = getValueList()
    // 质检报告
    // params.quality_inspection_report.show = refs.value[3].uploadList.length ? true : false
    // params.quality_inspection_report.value = refs.value[3].uploadList[0].fileList.map(item => { return item.id })

    // 报告信息
    // refs.value[3].customFieldsList.forEach((element) => {
    //     let m = {
    //         children: [],
    //         deletable: true,
    //         key: element.key,
    //         name: element.name,
    //         required: false,
    //         show: element.show,
    //         type: 1,
    //         value: null,
    //         showUpload: false,
    //         showDelete: true,
    //         extra: {},
    //     }
    //     m.children = element.fieldsList.map(item => {
    //         return {
    //             children: [],
    //             deletable: false,
    //             key: item.key,
    //             name: item.name,
    //             // required: true,
    //             show: true,
    //             type: 2,
    //             unit: item.unit,
    //             value: item.value,
    //             required: item.required ? item.required : false,
    //         }
    //     })
    //     if (!element.showUpload) {
    //         // m.key = `文本项-${index}`
    //         m.extra.myKey = '文本项'
    //         m.extra.showUpload = element.showUpload
    //         m.extra.showDelete = element.showDelete
    //     } else {
    //         // m.key = `文本项+附件项-${index}`
    //         m.extra.myKey = '文本项+附件项'
    //         m.extra.showUpload = element.showUpload
    //         m.extra.showDelete = element.showDelete
    //         m.extra.id = element.id
    //         m.extra.accept = element.accept
    //         m.extra.fileList = element.fileList
    //         m.extra.fileMaxSize = element.fileMaxSize
    //         m.value = element.fileList.map(item => { return item.id })
    //     }
    //     params.quality_inspection_report.children.push(m)
    // });
    // 其他信息
    refs.value[tabList.value.length - 1].customFieldsList.forEach((element) => {
        let m = {
            children: [],
            deletable: true,
            key: element.key,
            name: element.name,
            name_en: element.name_en,
            required: false,
            show: element.show,
            type: 1,
            value: null,
            showUpload: false,
            showDelete: true,
            extra: {},
        }
        m.children = element.fieldsList.map(item => {
            return {
                children: [],
                deletable: false,
                key: item.key,
                name: item.name,
                name_en: item.name_en,
                // required: true,
                show: true,
                type: 2,
                unit: item.unit,
                value: item.value,
                required: item.required ? item.required : false,
            }
        })
        if (!element.showUpload) {
            // m.key = `文本项-${index}`
            m.extra.myKey = '文本项'
            m.extra.showUpload = element.showUpload
            m.extra.showDelete = element.showDelete
        } else {
            // m.key = `文本项+附件项-${index}`
            m.extra.myKey = '文本项+附件项'
            m.extra.showUpload = element.showUpload
            m.extra.showDelete = element.showDelete
            m.extra.id = element.id
            m.extra.accept = element.accept
            m.extra.fileList = element.fileList
            m.extra.fileMaxSize = element.fileMaxSize
            m.value = element.fileList.map(item => { return item.id })
        }
        params.extra_info.children.push(m)
    });

    // console.log(params)
    //提交数据
    let x = true
    myLoading.value = true;
    if (x) {
        if (route.query.id) {
            // let table_name = route.query.t_name
            const resp = await putProduct(route.query.id, params)
            myLoading.value = false;
            if (resp) {
                openAlert({
                    variant: resp.code == 1 ? "danger" : 'success',
                    content: resp.code == 1 ? resp.message : getLangValue("base.edit_success"),
                }, 2000);
                if (resp.code == 0) {
                    setTimeout(() => {
                        // 返回上一页
                        // history.go(-1);
                        // 获取上一页信息
                        const url = route.query.from || ''
                        if (url) {
                            window.location.href = url
                        } else {
                            window.close();
                        }

                    }, 1000)
                }
            }
        } else {
            params.production_line_id = route.query.p_id;
            const resp = await postProduct(params)
            myLoading.value = false;
            if (resp) {
                openAlert({
                    variant: resp.code == 1 ? "danger" : 'success',
                    content: resp.code == 1 ? resp.message=='PID重复，请检查批次号和尺寸'? getLangValue("product-management.pid_repeat"):resp.message : getLangValue("base.add_success"),
                });
                if (resp.code == 0) {
                    setTimeout(() => {
                        // 返回上一页
                        // history.go(-1);
                        const url = route.query.from || ''
                        if (url) {
                            window.location.href = url
                        } else {
                            window.close();
                        }
                    }, 1000)
                }
            }
        }
    }


}
/**数据保存部分 */

const getptDetail = async () => {
    /**获取模板详情 by id */
    myLoading.value = true
    let resp = {}
    if (route.query.id) {
        table_name.value = route.query.t_name
        // 获取详情信息
        resp = await getProductDetail(route.query.id)
        if (resp.code == 1) {
            openAlert({
                variant: "danger",
                content: resp.message
            });
            return false
        }
    } else {
        // 获取模板信息
        resp = await database_default_data_v3({ production_line_id: route.query.p_id })
        if (resp.code == 1) {
            openAlert({
                variant: "danger",
                content: resp.message
            });
            return false
        }
    }

    if (resp.code == 0) {
        // console.log(resp);
        // 设置信息
        const { template_info, } = resp.payload;
        //其中type==99 的是自己新增的
        // if id
        if (route.query.id) {
            formData.value.title = template_info.name;
            formData.value.title_en = template_info.name_en;
            template_info.children.filter(item => ((item.extra && (!item.extra.type || item.extra.type != 99))) || !item.extra).forEach(item => {
                for (let i in formData.value.fieldsList) {
                    if (item.key == formData.value.fieldsList[i].key) {
                        // 获取里面的信息
                        formData.value.fieldsList[i].name = item.name
                        formData.value.fieldsList[i].name_en = item.name_en
                        formData.value.fieldsList[i].label = item.name
                        formData.value.fieldsList[i].label_en = item.name_en
                        formData.value.fieldsList[i].deletable = item.deletable
                        formData.value.fieldsList[i].extra = item.extra
                        formData.value.fieldsList[i].required = true
                        formData.value.fieldsList[i].show = item.required
                        formData.value.fieldsList[i].type1 = item.type
                        formData.value.fieldsList[i].value = item.value
                        if (formData.value.fieldsList[i].key == 'PLID') {
                            // console.log(item.extra);
                            formData.value.fieldsList[i].prefix = item.extra.prefix
                        }
                        if (item.value_en) {
                            formData.value.fieldsList[i].value_en = item.value_en
                        }
                        // if (item.key == '生产线名称') {
                        //     formData.value.fieldsList[i].label = '产品线名称'
                        // }
                        // if (item.key == '生产线编号') {
                        //     formData.value.fieldsList[i].label = '产品线编号'
                        // }
                        // if (formData.value.fieldsList[i].key == 'PID') {
                        //     formData.value.fieldsList[i].prefix = item.extra.prefix
                        // }
                        // if (item.name == 'HSCode' || item.name == '数据库名称' || item.key == '描述') {
                        //     formData.value.fieldsList[i].extra = { disabled: true }
                        // }
                        if (item.key == 'template_info_hscode' || item.key == 'template_info_destination_market' || item.key == 'template_info_template_name' || item.key == 'template_info_description' || item.key == 'template_info_place_of_origin' || item.key == 'template_info_production_line_name' || item.key == 'template_info_production_line_number') {
                            formData.value.fieldsList[i].extra = { disabled: true }
                        }
                        // if (item.key == 'HSCode数据库') {
                        //     formData.value.fieldsList[i].value = item.extra.value
                        // }
                        if (item.key == 'template_info_production_time') {
                            formData.value.fieldsList[i].value = item.extra && item.extra.value ? item.extra.value : item.value
                        }
                        if (item.key == 'template_info_place_of_origin') {
                            formData.value.fieldsList[i].list = [...company_address_list.value]
                        }
                        // if (item.key == '供应链') {
                        //     formData.value.fieldsList[i].value = []
                        // }
                        // if (item.name == 'HSCode' || item.name == '数据库名称') {
                        //     item.type = 'list'
                        //     item.extra = { disabled: true }
                        // }
                        if (item.key == 'template_info_production_line_name') {
                            // formData.value.fieldsList[i].label = '产品线名称'
                            // if (route.query.p_l_name) {
                                formData.value.fieldsList[i].value =  i18n.global.locale == 'en' ?  resp.payload.production_line?.production_line_name_en :  resp.payload.production_line?.production_line_name || route.query.p_l_name
                            // }
                        }
                    }
                }
            })
        } else {
            formData.value.title = template_info.name;
            formData.value.title_en = template_info.name_en;
            // product_info_base_info_inventory
            // product_info_base_info_batch_size
            // product_info_base_info_price
            // product_info_base_info_inventory_unit
            template_info.children.filter(item => item.key == 'template_info_hscode' || item.key == 'product_info_base_info_inventory' || item.key == 'product_info_base_info_price' || item.key == 'product_info_base_info_batch_size' || item.key == 'product_info_base_info_inventory_unit'  || !item.extra || (item.extra && (!item.extra?.type)) || (item.extra && item.extra.type && item.extra.type != '99')).forEach(item => {
                for (let i in formData.value.fieldsList) {
                    if (item.key == formData.value.fieldsList[i].key) {
                        // 获取里面的信息
                        formData.value.fieldsList[i].name = item.name
                        formData.value.fieldsList[i].name_en = item.name_en
                        formData.value.fieldsList[i].label = item.name
                        formData.value.fieldsList[i].label_en = item.name_en
                        formData.value.fieldsList[i].deletable = item.deletable
                        formData.value.fieldsList[i].extra = item.extra
                        formData.value.fieldsList[i].required = true
                        formData.value.fieldsList[i].show = item.required
                        formData.value.fieldsList[i].type1 = item.type
                        formData.value.fieldsList[i].value = item.value
                        if (item.value_en) {
                            formData.value.fieldsList[i].value_en = item.value_en
                        }
                        if (item.name == 'template_info_public_type') {
                            formData.value.fieldsList[i].value = ''
                        }
                        if (item.key == 'template_info_hscode' || item.key == 'template_info_destination_market' || item.key == 'template_info_template_name' || item.key == 'template_info_description' || item.key == 'template_info_place_of_origin' || item.key == 'template_info_production_line_name' || item.key == 'template_info_production_line_number') {

                            formData.value.fieldsList[i].extra = { disabled: true }
                        }
                        // if (item.key == 'HSCode数据库') {
                        //     formData.value.fieldsList[i].value = item.extra.value
                        // }
                        if (item.key == 'template_info_production_line_name') {
                            // formData.value.fieldsList[i].label = '产品线名称'
                            // if (route.query.p_l_name) {
                                formData.value.fieldsList[i].value =  i18n.global.locale == 'en' ?  resp.payload.production_line?.production_line_name_en :  resp.payload.production_line?.production_line_name || route.query.p_l_name
                            // }
                        }
                        if (item.key == 'template_info_production_line_number') {
                            // formData.value.fieldsList[i].label = '产品线编号'
                            if (route.query.p_l_no) {
                                formData.value.fieldsList[i].value = route.query.p_l_no
                            }
                        }
                        if (item.key == 'template_info_place_of_origin') {
                            formData.value.fieldsList[i].list = [...company_address_list.value]
                            if (route.query.p_o_o) {
                                formData.value.fieldsList[i].value = route.query.p_o_o
                            }
                        }
                        if (item.key == 'template_info_supply_chain') {
                            formData.value.fieldsList[i].value = []
                        }
                        // if (item.name == 'HSCode' ) {
                        //     item.type = 'list'
                        // }
                    }
                }

                // item.label = item.name
                // return item
            })
        }

        // formData.value.fieldsList = arr
        const arr1 = template_info.children.filter(item => item.extra && item.extra.type == 99).map(item => {
            item.label = item.name
            item.label_en = item.name_en
            return item
        })
        formData.value.addfieldsList = arr1
        // template_hscodeValue.value = template_info.children[1].value
        // 获取描述信息
        await getDescription();
        await getHscodeList();
        await get_user_company_address();
        await get_supply_chain_list();
        await getTemplateNameList();
        // 获取所有图片信息
        const imageInfo = await getProductImages(resp.payload);
        // 其他信息通过provide inject处理
        resp.payload.imageInfo = imageInfo
        // 获取动态指标数据
        setInfo(resp.payload.index_standard_info.value)
        // 设置tablist信息
        //产品信息别名
        tabList.value[0].name = resp.payload.product_info.name
        tabList.value[0].name_en = resp.payload.product_info.name_en
        // 舒适度信息别名
        tabList.value[1].name = resp.payload.comfort_info.name
        tabList.value[1].name_en = resp.payload.comfort_info.name_en
        // tabList.value[1].show = resp.payload.comfort_info.show
        // 报告别名
        // tabList.value[3].show = resp.payload.quality_inspection_report.show
        // tabList.value[3].name = resp.payload.quality_inspection_report.name
        // 其他信息
        tabList.value[tabList.value.length - 1].name_en = resp.payload.extra_info.name_en
        tabList.value[tabList.value.length - 1].name = resp.payload.extra_info.name
        // 设置信息
        detailInfo.value = resp.payload;
        // 设置成品样式与设计版型信息
        stylesPatternList.value = [...resp.payload?.production_line?.style || [], ...resp.payload?.production_line?.pattern || []];
        myLoading.value = false
    }
}
const getValueList = () => {
    // 数据整合
    for (let k in index_standards_list1.value) {
        //在这里处理多层数据 用不同的key
        const { children } = index_standards_list1.value[k]
        index_standards_list.value[`group_${k}`].indicatorList.forEach(item => {
            item.report = item.extra?.fileList && item.extra?.fileList.length > 0 ? item.extra.fileList.map(item => item.id) : []
        })

        index_standards_list1.value[k].index_standards = index_standards_list.value[`group_${k}`].indicatorList
        // 第二级
        if (children.length) {
            for (let kk in children) {
                const { children: children1 } = children[kk]
                index_standards_list.value[`group_${k}_${kk}`].indicatorList.forEach(item => {
                    item.report = item.extra?.fileList && item.extra?.fileList.length > 0 ? item.extra.fileList.map(item => item.id) : []
                })
                children[kk].index_standards = index_standards_list.value[`group_${k}_${kk}`].indicatorList
                // 第三级
                if (children1.length) {
                    for (const item3 in children1) {
                        index_standards_list.value[`group_${k}_${kk}_${item3}`].indicatorList.forEach(item => {
                            item.report = item.extra?.fileList && item.extra?.fileList.length > 0 ? item.extra.fileList.map(item => item.id) : []
                        })
                        children1[item3].index_standards = index_standards_list.value[`group_${k}_${kk}_${item3}`].indicatorList
                    }
                }
            }
        }
    }
    return [...index_standards_list1.value]
}

const setInfo = (index_standard_info) => {
    //倒叙
    index_standard_info = index_standard_info.reverse()
    // 需要根据指标组名称 动态显示
    tabList.value = [...tabList.value.filter(item => !item.type)]
    if (index_standard_info !== null && index_standard_info.length) {
        groupList1.value = []
        groupList2.value = []
        groupList3.value = []
        for (let k in index_standard_info) {
            //在这里处理多层数据 用不同的key
            const { children, group_name, group_name_en, index_standards } = index_standard_info[k]
            groupList1.value.push({
                name: group_name,
                name_en: group_name_en,
                id: `group_${k}`,
            });
            let m = {
                groupName: k,
                indicatorList: index_standards ? index_standards : [], //筛选为是否适用 ==是
            }
            index_standards_list.value[`group_${k}`] = m
            // 第二级
            if (children.length) {
                for (let kk in children) {
                    const { children: children1, group_name: group_name1, group_name_en: group_name1_en } = children[kk]
                    groupList2.value.push({
                        name: group_name1,
                        name_en: group_name1_en,
                        id: `group_${k}_${kk}`
                    });
                    let m = {
                        groupName: k,
                        indicatorList: children[kk].index_standards ? children[kk].index_standards : [],//筛选为是否适用 ==是
                    }
                    index_standards_list.value[`group_${k}_${kk}`] = m
                    // 第三级
                    if (children1.length) {
                        // let groupList_3 = [...new Set(children1.map(item => item.group_name))];
                        for (const item3 in children1) {
                            // console.log(item3);
                            const { group_name: group_name2, group_name_en: group_name2_en, index_standards: index_standards2 } = children1[item3]
                            groupList3.value.push({
                                name: group_name2,
                                name_en: group_name2_en,
                                id: `group_${k}_${kk}_${item3}`
                            });
                            let m = {
                                groupName: item3,
                                indicatorList: index_standards2 ? index_standards2 : [],//筛选为是否适用 ==是
                            }
                            index_standards_list.value[`group_${k}_${kk}_${item3}`] = m
                        }
                    }
                }

            }
        }
        index_standards_list1.value = [...index_standard_info]
        groupList.value = {
            groupList1: groupList1.value,
            groupList2: groupList2.value,
            groupList3: groupList3.value
        }
        // 如果group1大于0
        if (groupList1.value.length) {
            for (const item in groupList1.value) {
                tabList.value.splice(2, 0, {
                    name: groupList1.value[item].name,
                    name_en: groupList1.value[item].name_en,
                    type: 'instandard',
                    show: true,
                    canEdit: false,
                    id: groupList1.value[item].id,
                })
            }
        }
        // tabList.value.push({ name: '其他信息', com: otherInfoCom, ref: 'otherInfoRef', show: true, canEdit: true, })
    }
}

const setDetailValue = (key, value, valueKey = 'value') => {
    // 根据key 设置value
    let obj = formData.value.fieldsList.find(item => item.key == key)
    obj[valueKey] = value;
}

const setObjDetailValue = (data = {}, key, value, valueKey = 'value') => {
    // 根据key 设置value
    let obj = data.find(item => item.key == key)
    if (obj) {
        obj[valueKey] = value;
    }

}

const getDescription = async () => {
    // 获取hscode 描述详情
    let params = {
        ignore_fields: '["index_standards"]'
    }
    current_hscode.value = formData.value.fieldsList[2].value; // shcode
    const reps = await getHscodeDetail(formData.value.fieldsList[2].value, params)
    // console.log(reps);
    if (reps.code == 0) {
        formData.value.fieldsList[2].list = [...[
            {
                value: reps.payload.id,
                label: reps.payload.title
            }
        ]]
        // formData.value.fieldsList[3].value = reps.payload.description ? reps.payload.description : '-'
        setDetailValue('template_info_description', reps.payload.description ? reps.payload.description : '-')
        setDetailValue('template_info_description', reps.payload.description_en ? reps.payload.description_en : '-', 'value_en')
    }
}
const downloadExcel = async () => {
    // 下载excle模板
    const resp = await gethscode_management_excel({ hscode_id: current_hscode.value })
    const url = URL.createObjectURL(new Blob([resp.data])) // 文件流 blob 转成 URL
    const a = document.createElement('a')
    a.style.display = 'none'
    a.href = url
    a.download = `${current_hscode.value}_${new Date().getTime()}.xlsx` // 自定义下载文件的名称
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url); // 释放 URL 对象
}

const getProductImages = async (data) => {
    // 获取每个模块里面的图片  一起吊接口
    let imageIdList = []
    let imageInfo = {}
    const { product_info, comfort_info, quality_inspection_report, extra_info } = data
    // 获取产品信息里面的图片
    // const upList = product_info.children.filter(item => (item.key == '产品图片' || item.key == "2D版型" || item.key == "虚拟合身度") && item.show)
    const upList = product_info.children.filter(item => (item.key.indexOf('product_info_product_picture') > -1 || item.key.indexOf('product_info_product_style') > -1 || item.key.indexOf('product_info_product_pattern') > -1 || item.key.indexOf('product_info_virtual_fit') > -1 ||   item.key.indexOf('product_trademark') > -1) && item.show)
    if (upList.length) {
        upList.forEach((item) => {
            if (item.value && item.value != null && item.value.length)
                imageIdList = [...imageIdList, ...item.value]
        })
    }

    const csFieldList = product_info.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项"))
    if (csFieldList.length) {
        csFieldList.forEach(item => {
            if (item.value && item.value != null && item.value.length) {
                imageIdList = [...imageIdList, ...item.value]
            }
        })
    }
    // 舒适度信息
    const heList = comfort_info.children.filter(item => item.show && item.key == "comfort_info_humidity_heat_comfort")
    if (heList.length) {
        if (heList[0].value && heList[0].value.length) {
            imageIdList = [...imageIdList, ...heList[0].value]
        }
    }
    const cfList = comfort_info.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项") && item.extra.uukey)
    // console.log(comfort_info.children)
    if (cfList.length) {
        cfList.forEach(item => {
            if (item.value && item.value != null && item.value.length)
                imageIdList = [...imageIdList, ...item.value]
        })
    }

    const csFList = comfort_info.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项") && !item.extra.uukey)
    if (csFList.length) {
        csFList.forEach(item => {
            if (item.value && item.value != null && item.value.length)
                imageIdList = [...imageIdList, ...item.value]
        })
    }
    // 原来的质检报告
    // if (quality_inspection_report && quality_inspection_report.show) {
    //     if (quality_inspection_report.value && quality_inspection_report.value.length) {
    //         imageIdList = [...imageIdList, ...quality_inspection_report.value]
    //     }
    // }
    // 新的报告信息
    const reportList = quality_inspection_report.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项"))
    if (reportList.length) {
        reportList.forEach(item => {
            if (item.value && item.value != null && item.value.length)
                imageIdList = [...imageIdList, ...item.value]
        })
    }
    // 其他信息
    const etrList = extra_info.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项"))
    // console.log(extra_info.children)
    if (etrList.length) {
        etrList.forEach(item => {
            if (item.value && item.value != null && item.value.length)
                imageIdList = [...imageIdList, ...item.value]
        })
    }
    imageIdList = [...new Set(imageIdList)]
    if (imageIdList.length) {
        let ids = imageIdList.join(",")
        const res = await getFileUrl({ attachments: ids })
        if (res)
            res.payload.forEach(item => {
                item.filename = item.name
                imageInfo[item.id] = item
            })
    }
    return imageInfo
}

const handleChange = async (file,) => {
    // console.log(file, fileList, index);
    // 验证 类型 .png,.jpg,.jpeg,.pdf,.docx,.doc,.xlsx,.xls
    const fileFormat = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();
    const allowExtensions = ['xlsx', 'xls'];
    if (!allowExtensions.includes(fileFormat)) {
        showMessage('danger', getLangValue('upload.notCorrectType'))
        return;
    }
    //验证大小
    let data = await getExcelData(file.raw)
    // 去掉第一行数据
    data.shift()
    // 获取数据
    console.log(data);
    uploadData.value = data.map(item => {
        return {
            id: item[0],
            value: item[4],
            testing_institution: item[5], //检测机构
            qualification_of_testing_institution: item[6], //检测机构资质
            certification_date: item[7], // 检测日期
            validity_period_of_certification: item[8], //检测机构资质认证截止有效期
            certification_body: item[9], // 检测机构资质认证机构
        }
    })
}

function isValidDateMoment(dateString, format = 'YYYY-MM-DD') {
    // 用来验证输入的日期是否正确
    return moment(dateString, format, true).isValid();
}

const clearComfortInfoFtt = () => {
   // 清空指标舒适度信息 手感 肤感的值
   for (const key in index_standards_list.value) {
      let indicatorList = index_standards_list.value[key].indicatorList
      let arr = indicatorList.filter(item => item.category_name == 2)
      if(arr.length ==0){
        continue
      }
      let lsit = [
        getLangValueByKey('hand-feeling.smooth'),
        getLangValueByKey('hand-feeling.soft'),
        getLangValueByKey('hand-feeling.warmth'),
        getLangValueByKey('skin-feeling.pricking'),
        getLangValueByKey('skin-feeling.stiff'),
        getLangValueByKey('skin-feeling.cool'),
      ]
      // 清空 手感 肤感的值
      arr.filter(item => lsit.includes(item.name)).forEach(item => {
        item.value = ''
      })
   }
}

watch(templateId, (val) => {
    // 获取模板
    getptDetail(val)
})

watch(formData.value.fieldsList[9], (val) => {
    // console.log(val);
    // 设置值 批次号
    // refs.value[0].formData.fieldsList[8].value = val.value ? moment(val.value).format('YYYYMMDDHHmm') : '';
    setObjDetailValue(refs.value[0].formData.fieldsList, 'product_info_base_info_batch_number', val.value ? moment(val.value).format('YYYYMMDDHHmm') : '')
}, { deep: true })

watch(uploadData, (val) => {
    // 先筛选填了值的数据
    let filterData = val.filter(item => item.value)
    // 填入数据
    if (filterData.length == 0) return
    for (const item in index_standards_list.value) {
        const { indicatorList } = index_standards_list.value[item];
        for (const item1 in indicatorList) {
            const { id } = indicatorList[item1]
            // 筛选id
            let obj = filterData.find(item => item.id === id)
            if (obj) {
                indicatorList[item1].value = obj.value;
                indicatorList[item1].testing_institution = obj.testing_institution;
                indicatorList[item1].qualification_of_testing_institution = obj.qualification_of_testing_institution;
                indicatorList[item1].certification_date = isValidDateMoment(obj.certification_date) ? obj.certification_date : '';
                indicatorList[item1].validity_period_of_certification = isValidDateMoment(obj.validity_period_of_certification) ? obj.validity_period_of_certification : '';
                indicatorList[item1].certification_body = obj.certification_body;
                //提示
                showMessage('success', getLangValue('base.success'))
            }
        }
    }
})

onMounted(() => {
    // 获取数据
    getptDetail();
    // 配置tab
    if (route.query.origin) {
        // 产品列表菜单来的  显示的是所有产品数据  /productsList
        PageHeaderItems.value = [
            {
                text: getLangValue("product-management", "title"),
                active: false,
                href: "/productsList/",
            },
            {
                text: getLangValue("product-template", "productInfo"),
                active: true,
                href: "#",
            },
        ]
    } else {
        if (route.query.p_l_name) {
            if (PageHeaderItems.value.length == 2) {
                PageHeaderItems.value.push(
                    {
                        text: i18n.global.locale == 'en' ? `${route.query.p_l_name_en ? route.query.p_l_name_en : ''}`: `${route.query.p_l_name ? route.query.p_l_name : ''}`,
                        active: false,
                        href: `/products/${route.query.tid}?t_name=${route.query.t_name}&p_id=${route.query.p_id}&h_id=${route.query.h_id}&p_l_no=${route.query.p_l_no}&p_l_name=${route.query.p_l_name}&p_l_name_en=${route.query.p_l_name_en}&p_o_o=${route.query.p_o_o}&style=${route.query.style}&pattern=${route.query.pattern}&status=${route.query.status}&role_key=${route.query.role_key}`
                    },
                    {
                        text: getLangValue("product-template", "productInfo"),
                        active: true,
                        href: "#",
                    },
                )
            } else {
                PageHeaderItems.value[2].text = i18n.global.locale == 'en' ? route.query.p_l_name_en : route.query.p_l_name;
            }
            PageHeaderItems.value[1].href = ``
        } else {
            PageHeaderItems.value.push(
                {
                    text: getLangValue("product-template", "productInfo"),
                    active: true,
                    href: "#",
                },
            )
        }
    }
    // 获取所有的检测机构数据
    getCompanyList();
})

</script>
<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <div class="card bg-white px-3 " style="overflow-x: auto; height: calc(100vh - 160px);" v-loading="myLoading">
            <div class="text-end p-2">
                <b-button variant="light" class="waves-effect waves-light me-4" @click="handlerCancel()">{{
                    getLangValue("base.cancel") }}</b-button>
                <b-button style="background-color: #0AB39C;border-color: unset;" v-if="route.query.type != 'view'"
                    class="waves-effect waves-light" @click="handlerSubmit()">{{
                        getLangValue("base.done")
                    }}</b-button>
            </div>
            <div class="my-scroll-bar" style="overflow-y: auto; max-height: calc(100vh - 250px);">
                <!-- 模板信息部分 -->
                <basicFormCom v-model:formData="formData" ref="basicFormRef1" />
                <!-- tab部分 -->
                <!-- <ul class="nav nav-tabs nav-tabs-custom nav-success py-0 mb-2" role="tablist"
                    style="border-bottom: 1px solid #E9EBEC;">
                    <li class="nav-item" v-for="(tab, i) in tabList" :key="i">
                        <a :class="[
                            'nav-link',
                            'All',
                            'py-3',
                            'position-relative cursor',
                            i == current_tab && 'active',
                        ]" @click="handlerToggleTab(i, tab.id)" v-if="tab.show">{{ i18n.global.locale == 'en' ?
                            tab.name_en : tab.name }}</a>
                    </li>
                </ul> -->
                <div class=" d-flex justify-content-between align-items-center"
                    style="border-bottom: 1px solid #E9EBEC;">
                    <ul class="nav nav-tabs nav-tabs-custom nav-success py-0 mb-0 flex-1 " role="tablist"
                        style="border-bottom: unset;">
                        <!-- style="border-bottom: 1px solid #E9EBEC;" -->
                        <li class="nav-item" v-for="(tab, i) in tabList" :key="i">
                            <a :class="[
                                'nav-link',
                                'All',
                                'py-3',
                                'position-relative cursor',
                                i == current_tab && 'active',
                            ]" @click="handlerToggleTab(i, tab.id)" v-if="tab.show">{{ i18n.global.locale == 'en' ?
                                tab.name_en : tab.name }}</a>
                        </li>
                    </ul>
                    <div class="nav-item h-100" v-if="index_standards_list1.length">
                        <!-- 下载 -->
                        <button type="button" class="btn btn-success me-3" @click="downloadExcel">
                            <i class=" ri-download-cloud-2-line me-1 align-bottom"></i>
                            {{ getLangValue('product-template.download_indicator_template') }}
                        </button>
                        <!-- 上传 -->
                        <el-upload style="display: inline-block;" class="upload-demo" :auto-upload="false" multiple
                            :accept="'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
                            :on-change="(file, fileList) => handleChange(file, fileList,)" :show-file-list="false">
                            <button type="button" class="btn btn-success me-3">
                                <i class=" ri-upload-cloud-2-line me-1 align-bottom"></i>
                                {{ getLangValue('product-template.upload_indicator_template') }}
                            </button>
                        </el-upload>
                    </div>
                </div>
                <!-- tab切换组件 -->
                <template v-for="(tab, i) in tabList" :key="i">
                    <div v-show="i == current_tab">
                        <template v-if="tab.type == 'instandard'">
                            <indicatorstandardsCom :ref="addRefs(i)" :hscodeList="hscodeList"
                                :company_list="company_list" v-show="i == current_tab" :groupList="groupList"
                                :p_id="tab.id" />
                        </template>
                        <component :is="tab.com" :ref="addRefs(i)" :hscodeList="hscodeList" @clearComfortInfoFtt="clearComfortInfoFtt" v-else></component>
                    </div>
                </template>
            </div>
        </div>
        <message-alert :alertInfo="alertInfo" v-if="formValidataAlert"></message-alert>
    </Layout>
</template>

<style scoped>
:deep(.el-select__wrapper) {
    min-height: 37.5px;
}

:deep(.el-select__placeholder.is-transparent) {
    font-size: 0.8125rem;
    color: #878a99 !important;
}

:deep(.el-select__selected-item.el-select__placeholder) {
    font-size: 0.8125rem;
    color: #212529;
}

:deep(.el-cascader .el-input__inner) {
    font-size: 0.8125rem;
    color: #212529;
}

:deep(.el-cascader .el-input__inner::placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-webkit-input-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-moz-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-moz-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-ms-input-placeholder) {
    color: #878a99;
}
</style>
